import { render, staticRenderFns } from "./UpdateCallRecord.vue?vue&type=template&id=7c30754c&scoped=true&"
import script from "./UpdateCallRecord.vue?vue&type=script&lang=js&"
export * from "./UpdateCallRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30754c",
  null
  
)

export default component.exports